export class ForgotPasswordModel {
  public userName: string;
  public password: string;
  public confirmPassword: string;
  public personActivationLink: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/forgotpassword/models/forgotpassword.model.ts